import React, { useMemo } from "react";
import LiveTracking from "../../WorkRoutes/components/LiveTracking";

const DeliveryLiveTracking = ({ deliveryUsers = [] }) => {
  const employees = useMemo(
    () =>
      deliveryUsers.map((u) => ({
        employee_id: u.id,
        employee_name: u.full_name,
      })),
    [deliveryUsers]
  );

  return (
    <LiveTracking
      employees={employees}
      center={{ lat: 25.2048, lng: 55.2708 }}
      zoom={11}
    />
  );
};

export default DeliveryLiveTracking;
